<template>
    <TabWrapper @save="submit" @change="change" @deploy:preview="$emit('deploy:preview')"
                @deploy:live="$emit('deploy:live')">
        <v-container fluid>
            <v-row row justify="center">
                <v-col col="12" lg="10">
                    <Textarea :key="key" v-model="includesCondition" label="Include Bedingung" :rows="7"
                              :disabled="readOnly"></Textarea>
                    <Datatable :items="includes" :headers="tableHeaders" title="Includes"
                               @click:row="openActionDialog">
                        <template #top>
                            <div v-if="!readOnly"
                                 style="display:flex; align-items: center">
                                <Button v-if="$vuetify.breakpoint.mdAndUp" class="ml-8"
                                        icon="mdi-plus" @click="openActionDialog(null)"
                                        :color="ada.blue">Include hinzufügen
                                </Button>
                                <TooltipIcon v-else :color="ada.blue" :fab="true"
                                             @click="openActionDialog(null)"
                                             tooltip="Include hinzufügen">mdi-plus
                                </TooltipIcon>
                            </div>
                        </template>
                    </Datatable>
                </v-col>
            </v-row>
        </v-container>
        <IncludeDialog v-model="showIncludesDialog" :include="selectedInclude"
                       :includeDetails="includeDetails" :includeDetailsLoading="includeDetailsLoading"
                       @delete="showDeleteIncludeDialog = true;"></IncludeDialog>
        <DeleteIncludeDialog v-model="showDeleteIncludeDialog" :include="selectedInclude"
                             :includeDetails="includeDetails"
                             @deleted="showIncludesDialog = false"
                             :includeDetailsLoading="includeDetailsLoading"></DeleteIncludeDialog>
    </TabWrapper>
</template>

<script>
import TabWrapper from "./TabWrapper";
import Textarea from "../../../components/Inputs/Textarea";
import Button from "../../../components/buttons/Button";
import ada from "../../../scss/ada_colors.scss"
import IncludeDialog from "../Dialogs/IncludeDialog";
import DeleteIncludeDialog from "../Dialogs/DeleteIncludeDialog";
import TooltipIcon from "../../../components/TooltipIcon";
import Datatable from "../../../components/Tables/Datatable";

export default {
    name: "Includes",
    components: {Datatable, TooltipIcon, DeleteIncludeDialog, IncludeDialog, Button, Textarea, TabWrapper},
    props: ['readOnly'],
    data: () => {
        return {
            includesCondition: null,
            showIncludesDialog: false,
            selectedInclude: null,
            include_search: null,
            showDeleteIncludeDialog: false,
            key: 1,
            tableHeaders: [
                {text: 'Includes', value: 'Name'},
                {text: 'Aktion', value: 'action', width: '100px', sortable: false},
            ],
            includeDetails: null,
            includeDetailsLoading: false,
            ada
        }
    },
    mounted() {
        this.init();
        this.$emit('activeComponent', this);
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        includes() {
            let includes = this.siteDetails ? this.siteDetails.Include : [];
            includes.forEach((include) => {
                include.action = ['edit'];
                if (!this.readOnly) include.action.push('delete');
            });
            return includes;
        },
        activeTab() {
            return this.vuexState.activeTab;
        }
    },
    methods: {
        init() {
            if (this.siteDetails) {
                this.includesCondition = this.siteDetails.Current.IncludeCondition;
            }
        },
        async fetchIncludeDetails() {
            this.includeDetails = null;
            this.includeDetailsLoading = true;
            let data = await this.$store.dispatch('display/fetchIncludeDetails', this.selectedInclude.Id);
            this.includeDetails = data.Current;
            this.includeDetailsLoading = false;
        },
        openActionDialog(item, action = 'edit') {
            this.selectedInclude = item;
            if (action === 'delete') {
                this.showDeleteIncludeDialog = true;
            } else {
                this.openDialog(item);
            }

        },
        submit() {
            this.$emit('submit', this);
        },
        change() {
            if (this.vuexState.previousTab === this.$options._componentTag) {
                this.$emit('change', this);
            } else if (this.activeTab === this.$options._componentTag) {
                this.$emit('activeComponent', this);
            }
        },
        dataChanged() {
            let changed = false;
            if (this.includesCondition !== this.siteDetails.Current.IncludeCondition) {
                changed = true;
            }
            return changed;
        },
        getBody() {
            return {
                publisher_id: this.siteDetails.Site.PublisherId,
                site_id: this.siteDetails.Site.SiteId,
                type_id: this.siteDetails.Current.SitetypeId,
                IncludeCondition: this.includesCondition
            }
        },
        openDialog(item) {
            if (item === null) this.selectedInclude = null;
            this.showIncludesDialog = true;
        },
    },
    watch: {
        selectedInclude() {
            if (this.selectedInclude) {
                this.fetchIncludeDetails();
            } else {
                this.includeDetails = null;
            }
        },
        siteDetails() {
            this.init();
        }
    }
}
</script>

<style lang="scss" scoped>
tr {
    cursor: pointer;
}

</style>